import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import SelectTask from '../settingsComponents/SelectTaskAdmin';
import List from '@mui/material/List';
import { t } from 'i18next';
import Button from '@mui/material/Button';

interface User {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  role: {
    id: number,
    title: string
  },
  company: {
    id: number,
    title: string
  },
  supervisorId: number;
}

interface AddModalProps {
  selectCategoryName: string,
  setOpenAddCategory: any,
  selectedCatogoryId: any,
  updateTree: any;
}


const AddCategory: React.FC<AddModalProps> = ({ selectCategoryName, setOpenAddCategory, selectedCatogoryId, updateTree }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [newCategory, setNewCategory] = useState('');
  const handleClose = () => setOpenAddCategory(false);
  const [selectedTask, setSelectedTask] = useState<any[]>([]);
  const [selectedSupervisor, setSelectedSupervisor] = useState<any | null>(null);
  const [users, setUsers] = useState<User[]>([]);
  const [isPasteDisabled, setIsPasteDisabled] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      try {
        const { data: usersData } = await axios.get('users');
        setUsers(usersData);
        setSelectedSupervisor(null);
      } catch (e) {
      }
    })();
  }, []);

  useEffect(() => {
    const copiedTasks = localStorage.getItem('copiedTasks');
    setIsPasteDisabled(!copiedTasks);
  }, []);

  const handleAddCategory = async () => {
    try {
      if (!newCategory || !newCategory.trim()) {
        enqueueSnackbar('Add name category', { variant: 'error' });
        return
      }
      await axios.post('category/add', {
        name: newCategory,
        description: '1',
        parentId: selectedCatogoryId !== -1 ? Number(selectedCatogoryId) : null,
        taskId: selectedTask.map((task: any) => task.value),
        supervisorId: selectedSupervisor
      });
      setNewCategory('')
      updateTree();
      handleClose();
      setSelectedSupervisor(null);
      enqueueSnackbar(`Add child category for ${selectCategoryName}`, { variant: 'success' });
    } catch (error: any) {
      console.error('Error', error);
      enqueueSnackbar('Error', { variant: 'error' });
    }
  };

  const handleCopyTasks = () => {
    localStorage.setItem('copiedTasks', JSON.stringify(selectedTask));
    setIsPasteDisabled(false);
    enqueueSnackbar('Tasks copied successfully', { variant: 'success' });
  };

  const handlePasteTasks = () => {
    const copiedTasks = localStorage.getItem('copiedTasks');
    if (copiedTasks) {
      setSelectedTask(JSON.parse(copiedTasks));
      enqueueSnackbar('Tasks pasted successfully', { variant: 'success' });
    } else {
      enqueueSnackbar('No tasks to paste', { variant: 'error' });
    }
  };

  return (
    <Box sx={{
      width: 420,
      height: '200%',
      background: 'var(--bg-form)'
    }}
      role="presentation">
      <List>
        <div className='my-[5px] mx-[25px] text-[var(--text-color)]' id='reg-user-edit'>
          <div className='flex justify-end'>
            <h1 className='text-[20px] text-left font-bold'>{t('AddCategory')}</h1>
          </div>
          <hr className='hr mt-[20px] mb-[10px]' />
          <div className='flex flex-col w-full'>
            {selectedCatogoryId !== -1 ? (
              <label className='text-[10px] ml-[5px]'>
                {t('AddChildCategoryFor')} <span className='text-[12px] text-blue-400 font-semibold'>'{selectCategoryName}' :</span>
              </label>
            ) : (
              <label className='text-[10px] ml-[5px]'>{t('AddParentCategory')}:</label>
            )}
            <input
              className='w-full text-[18px] p-[4px] rounded-[5px] bg-[var(--bg-input)] text-[var(--text-color)] timesheet-edit-input'
              type="text"
              value={newCategory}
              onChange={(e) => setNewCategory(e.target.value)} />
          </div>
          <div className='flex flex-col my-[5px] '>
            <label className='text-[10px] ml-[5px]'>{t('SelectSupervisor')}:</label>
            <select
              className="edit-select p-[5px] rounded-[5px] edit-input"
              onChange={(e) => { setSelectedSupervisor(parseInt(e.target.value) || null) }}>
              <option key='none' value="null">none</option>
              {users
                ?.sort((a, b) => {
                  if (a.first_name < b.first_name) return -1;
                  if (a.first_name > b.first_name) return 1;
                  return 0;
                })
                .map((user) => (
                  <option key={user.id} value={user.id} >
                    {user.first_name} {user.last_name}
                  </option>
                ))}
            </select>
          </div>
          <div className='flex flex-col w-full my-[10px] '>
            <label className='text-[10px] ml-[5px]'>{t('AddTasks')}:</label>
            <SelectTask
              selectedTask={selectedTask}
              setSelectedTask={setSelectedTask} />
          </div>
          <hr className='hr mt-[20px] mb-[10px]' />
          <div className='flex justify-end items-center gap-[10px]'>
            <Button
              variant="outlined"
              style={{
                fontSize: 12,
                padding: '2px 7px'
              }}
              onClick={handleCopyTasks}>
              {t('Copy Tasks')}</Button>
            <Button
              variant="outlined"
              style={{
                fontSize: 12,
                padding: '2px 7px'
              }}
              onClick={handlePasteTasks}
              className={isPasteDisabled ? 'disabled:opacity-50' : ''}
              disabled={isPasteDisabled} >
              {t('Paste Tasks')}
              </Button>
          </div>
          <hr className='hr mt-[10px] mb-[15px]' />
          <div className='flex justify-between items-center gap-[10px]'>
            <Button
              variant="contained"
              sx={{
                padding: '4px 10px',
                fontSize: 14,
                width: '100%',
                color: 'white !important'
              }}
              onClick={() => handleAddCategory()}>
              {t('Add')}
            </Button>
            <Button
              variant="contained"
              sx={{
                padding: '4px 10px',
                fontSize: 14,
                width: '100%',
                color: 'white !important'
              }}
              onClick={() => handleClose()}>
              {t('Cancel')}
            </Button>
          </div>
        </div>
      </List>
    </Box >
  );
}

export default AddCategory;